export const appLoaderTheme = {
  0: 'palette.tertiary.5',
  100: 'palette.transparent',
  50: 'palette.surface.4',
  70: 'palette.surface.3',
};
